/* eslint-disable no-debugger */
import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from 'axios';
import { getModuleRoles } from './users__';

const initialState = {
  isLoading: false,
  error: '',
  userRoleMsg: '',
  status: true,
  createUserRoleStatus: false,
  userRoleList: [],
  disableUserRoleList: [],
  moduleList: []
};

const slice = createSlice({
  name: 'user_role',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // RESET ERROR
    resetUserRoleError(state) {
      state.error = '';
    },
    // RESET MSG
    resetUserRoleMsg(state) {
      state.userRoleMsg = '';
    },
    // HAS ERROR
    hasError(state, action) {
      const { message } = action.payload?.data;
      state.createUserRoleStatus = false;
      state.isLoading = false;
      state.error = message;
    },
    // STATUS
    userRoleStatus(state, action) {
      state.isLoading = false;
      state.status = action.payload;
    },
    // GET USERS LIST
    getUserRoleListSuccess(state, action) {
      state.isLoading = false;
      state.userRoleList = action.payload;
    },
    // GET DISABLE USERS LIST
    getDisableUserRoleSuccess(state, action) {
      state.disableUserRoleList = action.payload;
      state.isLoading = false;
    },
    // GET ALL MODULE LIST
    getAllModuleListSuccess(state, action) {
      const { permissions } = action.payload;
      state.isLoading = false;
      state.moduleList = permissions;
    },
    // RESET CREATE STATUS
    resetCreateUserRoleStatus(state) {
      state.createUserRoleStatus = false;
    },
    // CREATE USERS
    createUserRoleSuccess(state, action) {
      const newUserRole = action.payload;
      state.createUserRoleStatus = true;
      state.isLoading = false;
      state.userRoleList = [...state.userRoleList, newUserRole];
    },
    // UPDATE USERS
    updateUserRoleSuccess(state, action) {
      const role = action.payload;
      state.createUserRoleStatus = true;
      const updateRole = map(state.userRoleList, (_role) => {
        if (_role.id === role.id) {
          return role;
        }
        return _role;
      });
      state.isLoading = false;
      state.userRoleList = updateRole;
    },
    // FILTER USERS
    filterUserRoleSuccess(state, action) {
      const role = action.payload;
      state.isLoading = false;
      if (state.status) {
        state.userRoleList = role;
      } else {
        state.disableUserRoleList = role;
      }
    },
    // DISABLE OR RESTORE USERS
    statusChangeSuccess(state, action) {
      if (action.payload.message) {
        state.userRoleMsg = action.payload.message;
      } else {
        const { id } = action.payload;
        const userRoleStatus = filter(
          state.status ? state.disableUserRoleList : state.userRoleList,
          (role) => role.id !== id
        );
        state.isLoading = false;
        if (state.status) {
          state.createUserRoleStatus = false;
          state.userRoleMsg = '';
          state.disableUserRoleList = userRoleStatus;
        } else {
          state.createUserRoleStatus = true;
          state.userRoleList = userRoleStatus;
        }
      }
    },
    // DELETE USERS
    deleteUsersSuccess(state, action) {
      const { id } = action.payload;
      const deleteEvent = filter(state.disableUserRoleList, (role) => role.id !== id);
      state.isLoading = false;
      state.disableUserRoleList = deleteEvent;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { resetCreateUserRoleStatus, resetUserRoleError, resetUserRoleMsg } = slice.actions;

// ----------------------------------------------------------------------

//  GET ALL MODULE LIST GET
export function getAllModuleList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        url: 'http://smartcollect-api.cp360apps.com/cp360adminlogin/permission-list/'
      });
      dispatch(slice.actions.getAllModuleListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// GET USER ROLE LIST GET
export function getUserRoleList(status) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/cp360adminlogin/user-role/filter/item/?status=${status}`
      });
      if (status) {
        dispatch(slice.actions.getUserRoleListSuccess(response.data));
      } else {
        dispatch(slice.actions.getDisableUserRoleSuccess(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// CREATE USER ROLE POST
export function createUserRole(userRoleData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: 'http://smartcollect-api.cp360apps.com/cp360adminlogin/user-role-create/',
        data: userRoleData
      });
      dispatch(slice.actions.createUserRoleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// EDIT OR UPDATE USER ROLE PUT
export function updateUserRole(userRoleData, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/cp360adminlogin/user-role/edit/${id}/`,
        data: userRoleData
      });
      dispatch(slice.actions.updateUserRoleSuccess(response.data));
      dispatch(getModuleRoles());
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// SEARCH AND FILTER USER ROLE GET
export function filterUserRole(pageStatus, name) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.userRoleStatus(pageStatus));
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/cp360adminlogin/user-role/filter/item/?status=${pageStatus}&access_profile_name=${name}`
      });
      dispatch(slice.actions.filterUserRoleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// DISABLING OR RESTORING OF PARTICULAR USER ROLE PUT
export function statusChange(id, status) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.userRoleStatus(status));
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/cp360adminlogin/user-role-update-status-${status}/${id}/`
      });
      dispatch(slice.actions.statusChangeSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// DELETE USER ROLE
export function deleteUserRole(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'delete',
        url: `http://smartcollect-api.cp360apps.com/cp360adminlogin/user-role-delete/${id}/`
      });
      dispatch(slice.actions.deleteUsersSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// ----------------------------------------------------------------------
